import { ComponentProps } from "react";
import clsx from "clsx";

export const NavbarSeparator = ({ className, ...rest }: ComponentProps<"div">) => {
  return (
    <div
      className={clsx("w-px self-center h-6 rounded-full bg-border-base-divider shrink-0", className)}
      aria-hidden
      {...rest}
    />
  );
};
